import { IDateRange } from "@/core/composables/F360DateShortcuts/types";
import { IUseLocalFiltersStoreMixins } from "./UseLocalFilterStoreMixins";
import { useLocalFilterStore } from "./useLocalFilterStore";
import { TLocalFilter } from "./types";
import { injectable } from "inversify";
import "reflect-metadata";

@injectable()
export default class UseLocalFilterStoreMixinsAdapter
  implements IUseLocalFiltersStoreMixins
{
  private readonly filterStore: ReturnType<typeof useLocalFilterStore>;

  constructor() {
    this.filterStore = useLocalFilterStore();
  }

  saveFilter(data: TLocalFilter): void {
    this.filterStore.saveFilter(data);
  }

  updateShortcut(
    cardId: number,
    value: number,
    range?: IDateRange | undefined
  ): void {
    this.filterStore.updateShortcut(cardId, value, range);
  }

  clearFilter(cardId: number): void {
    this.filterStore.clearFilter(cardId);
  }
}
